import { BottomSheet } from "./BottomSheet"
import { useMeals } from "../hooks/useMeals"
import { MealItem } from "./MealItem"
import { SetStateAction, useState } from "react";
import { IMeal, WeekDaysEnum } from "../types/types";
import { Box, TextField, Typography } from "@mui/material";
import { useSnackbar } from "./Snackbar";
import { useMenu } from "../hooks/useMenu";
import { mapDays } from "./sortable/WeekdayOverlay";

declare global {
  interface Array<T> {
    findLast(predicate: (value: T, index: number, element: T[]) => unknown): T;
    findLastIndex(
      predicate: (value: T, index: number, obj: T[]) => unknown,
      thisArg?: any
    ): number;
  }
}

export const MealListModal = ({
  isOpen,
  handleClose,
  handleOpen,
  setMenu,
  activeTab
}: {
  isOpen: boolean,
  handleClose: () => void,
  handleOpen: () => void,
  setMenu: (value: SetStateAction<IMeal[]>) => void,
  activeTab: number
}) => {
  const { meals } = useMeals();
  const { menu } = useMenu();
  const [searchValue, setSearchValue] = useState('');
  const filteredMeals = meals.filter((m) => m.name.toUpperCase().includes(searchValue.toUpperCase()));
  const { Snackbar, setSnackbarStatus } = useSnackbar();

  const addedToDay = (day: WeekDaysEnum) => mapDays[day];

  const handleSetMenu = async (updater: ((prev: IMeal[]) => IMeal[]) | IMeal[]) => {
      let value = menu
      if (typeof updater === "function") {
        value = updater(value);
      } else {
        value = updater;
      }
      try {
        setMenu(value)
        setSnackbarStatus("done");
      } catch (err) {
        console.error("Błąd aktualizacji menu:", err);
      } finally {
        setTimeout(() => {
          setSnackbarStatus("idle")
        }, 1000)
      }
    }

  return (
    <BottomSheet isOpen={isOpen} handleClose={handleClose} handleOpen={handleOpen}>
      <TextField value={searchValue} onChange={(e) => setSearchValue(e.target.value)} sx={{ width: '100%', marginBottom: 2 }} placeholder="Wyszukaj posiłek..." />
      {filteredMeals.length > 0 ? filteredMeals.map((meal) => (
        <MealItem meal={meal} setCart={handleSetMenu} addingToMenu={activeTab} />
      )) : (
        <Box sx={{ p: 3, display: 'flex', justifyContent: 'center', alignItems: "center", flexDirection: "column", paddingTop: 8 }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-shopping-bag w-16 h-16 text-gray-300 mb-4" data-fg-cxtk1="5.12:5.5215:/components/Cart.tsx:29:9:808:56:e:ShoppingBag::::::sRE"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"></path><path d="M3 6h18"></path><path d="M16 10a4 4 0 0 1-8 0"></path></svg>
          <Typography sx={{ marginBottom: 1 }} color="#6a7282">Nie znaleziono posiłków</Typography>
      </Box>
      )}
      <Snackbar messages={{ done: `Dodano posiłek do ${addedToDay(Object.values(WeekDaysEnum)[activeTab])}`, working: "Dodawanie posiłku" }} />
    </BottomSheet>
  )
}
